
import { Component, Prop, Vue } from "vue-property-decorator";
import { AddressType } from "@/dtos/addressType";
import { AddressDto } from "@/dtos/addressDto";
import AddressTile from "@/components/AddressTile.vue";

@Component({
	components: {
		AddressTile,
	},
})
export default class AddressesOverview extends Vue {
	@Prop()
	private type!: AddressType;
	private addresses: AddressDto[] = new Array<AddressDto>();
	private addressesLoaded: boolean = false;

	private mounted() {
		this.setAddress();
	}

	private setAddress() {
		let copyAddresses: AddressDto[] = [];
		switch (this.type) {
			case AddressType.CustomerPersonal:
				let copyAddresses = new Array<AddressDto>();
				copyAddresses.push(
					JSON.parse(JSON.stringify(this.$store.getters.customerPersonalAddress))
				);
				this.addresses = copyAddresses;
				break;
			case AddressType.CustomerDelivery:
				copyAddresses = JSON.parse(
					JSON.stringify(this.$store.state.detailCustomerDetails.deliveryAddresses)
				);
				this.addresses = copyAddresses;
				break;
			case AddressType.CustomerInvoice:
				copyAddresses = JSON.parse(
					JSON.stringify(this.$store.state.detailCustomerDetails.invoiceAddresses)
				);
				this.addresses = copyAddresses;
				break;
			default:
				this.addresses = [];
				break;
		}
		this.addressesLoaded = true;
	}
}
